import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";


export const LinkInstagramIcon = <a href='https://www.instagram.com/' className='social' target="_BLANK"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg></a>
export const LinkFacebookIcon = <a href='https://www.facebook.com/' className='social' target="_BLANK"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M80 299.3l0 212.7 116 0 0-212.7 86.5 0 18-97.8-104.5 0 0-34.6c0-51.7 20.3-71.5 72.7-71.5 16.3 0 29.4 .4 37 1.2l0-88.7C291.4 4 256.4 0 236.2 0 129.3 0 80 50.5 80 159.4l0 42.1-66 0 0 97.8 66 0z"/></svg></a>
export const LinkLinkedinIcon = <a href='https://www.linkedin.com/company/yaskia-sa/' className='social' target="_BLANK"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M196.3 512L103.4 512L103.4 212.9L196.3 212.9L196.3 512zM149.8 172.1C120.1 172.1 96 147.5 96 117.8C96 103.5 101.7 89.9 111.8 79.8C121.9 69.7 135.6 64 149.8 64C164 64 177.7 69.7 187.8 79.8C197.9 89.9 203.6 103.6 203.6 117.8C203.6 147.5 179.5 172.1 149.8 172.1zM543.9 512L451.2 512L451.2 366.4C451.2 331.7 450.5 287.2 402.9 287.2C354.6 287.2 347.2 324.9 347.2 363.9L347.2 512L254.4 512L254.4 212.9L343.5 212.9L343.5 253.7L344.8 253.7C357.2 230.2 387.5 205.4 432.7 205.4C526.7 205.4 544 267.3 544 347.7L544 512L543.9 512z"/></svg></a>

export const LinkHome = () => {
  
  const { t } = useTranslation();
  const location = useLocation();
  const isEnglish = location.pathname.startsWith("/en");

  return (
    <Link to={isEnglish ? "/en" : "/"} className="button">
      {t("nav.home")}
    </Link>
  );
};

export const LinkQuienesSomos = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isEnglish = location.pathname.startsWith("/en");
  return (
    <Link to={isEnglish ? "/en/about" : "/quienes-somos"} className="button">
      {t("nav.about")}
    </Link>
  );
};

export const LinkProductos = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isEnglish = location.pathname.startsWith("/en");
  return (
    <Link to={isEnglish ? "/en/products" : "/productos"} className="button">
      {t("nav.products")}
    </Link>
  );
};

export const LinkOperacion = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isEnglish = location.pathname.startsWith("/en");
  return (
    <Link to={isEnglish ? "/en/operation" : "/nuestra-operacion"} className="button">
      {t("nav.operation")}
    </Link>
  );
};

export const LinkContacto = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isEnglish = location.pathname.startsWith("/en");
  return (
    <Link to={isEnglish ? "/en/contact" : "/contacto"} className="button">
      {t("nav.contact")}
    </Link>
  );
};